import React, { useState, useEffect, useRef } from 'react';

interface TemplateEditorProps {
    content: string;
    onChange: (content: string) => void;
    readOnly?: boolean;
}

const TemplateEditor: React.FC<TemplateEditorProps> = ({ content, onChange, readOnly }) => {
    const [localContent, setLocalContent] = useState(content);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    // Update local content when prop changes (e.g., when a new template is selected)
    useEffect(() => {
        setLocalContent(content);
    }, [content]);

    // Handle change with debouncing
    const handleChange = (value: string) => {
        setLocalContent(value);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            onChange(value);
        }, 500); // 500ms debounce
    };

    // Sync immediately on blur
    const handleBlur = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        onChange(localContent);
    };

    return (
        <div className="h-full w-full bg-slate-900">
            <textarea
                className="w-full h-full p-4 bg-slate-900 text-slate-300 font-mono text-sm focus:outline-none resize-none disabled:opacity-50"
                value={localContent}
                onChange={(e) => handleChange(e.target.value)}
                onBlur={handleBlur}
                disabled={readOnly}
                placeholder={readOnly ? "Select a template to start editing..." : "Enter HTML content here..."}
                spellCheck={false}
            />
        </div>
    );
};

export default TemplateEditor;
